import {
  NeuronProvider as Provider,
  Neuron,
  type SPAConfig,
} from "@sphtech/neuron";
import { NEURON_CONFIG_URL } from "@helper/getEnvVariables";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

Neuron.default.setConfig({});

export default function NeuronProvider({ children }: Props): ReactNode {
  const neuronConfig: SPAConfig = {
    sessionApiUrl: import.meta.env.VITE_NEURON_API_URL,
    sessionApiToken: import.meta.env.VITE_NEURON_API_TOKEN,
    segmentsApiUrl: import.meta.env.VITE_SEGMENTO_API_URL,
    extends: NEURON_CONFIG_URL ? [NEURON_CONFIG_URL] : [],
  };
  return <Provider config={neuronConfig}>{children}</Provider>;
}
